import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  userInfo: {},
  poiInfo: null,
  authrorizeType: "",
  cutOffTimeList: [],
  permissionListMenu: [],
  permissionListBtn: [],
  PVCheck: "",
  dataEndTime: "--",
  consumingPriceAvg: null,       // 营销活动笔单价 单位分
  fcStatus: null,            // 全渠道绑定状态 影响 sideNav 菜单显示 1 => 已开通 2 => 未开通
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js